import React from 'react';

import {FooterModuleStoreButtons} from "../footer-module.store-buttons";
import {FooterModuleSocialButtons} from "../footer-module.social-buttons";

export const FooterModuleMobileSocialStoreButtons = ({controller}) => {
  return (
    <>
      <FooterModuleStoreButtons controller={controller}/>
      <FooterModuleSocialButtons controller={controller} />
    </>
  );
}
